module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Db-Ef-Fb-Gb.76ad0369.png";